
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema({
    entity: ActivityEntityName.ContactLink,
    name: 'ContactLinkMergeSchema'
})
export class ContactLinkMergeData {

    entityId: string;
    entityType: string;

    @MergeField()
    contactId?: string;

    @MergeField()
    contactType?: string;

    @MergeField()
    name: string;

    @MergeField()
    email: string;

    @MergeField()
    phone: string;

    @MergeField()
    mobile: string;

    @MergeField()
    tags: string;

}

export const ContactLinkMergeSchema = getSchema(ContactLinkMergeData);